import { useLocalStorageManager } from '@0x234/common-vue/composables/local-storage-manager';
import { defineStore } from 'pinia';
import { SiteContext } from 'router/routes';
import { computed } from 'vue';

export const useSiteContextStore = defineStore('site-context', () => {
    const { storeRef } = useLocalStorageManager();

    const activeSiteContext = storeRef('site-context/active', SiteContext.JobSeeker);

    const hasActiveSiteContext = computed(() => {
        return activeSiteContext.value !== null;
    });

    const isEmployerSiteContext = computed(() => {
        return activeSiteContext.value === SiteContext.Employer;
    });

    function setSiteContext(ctx) {
        activeSiteContext.value = ctx;
    }

    return {
        activeSiteContext,
        hasActiveSiteContext,
        isEmployerSiteContext,
        setSiteContext
    };
});
